import React from "react";

export default function MaintenanceAlert({ message }) {
  return (
    <div className="alert alert-danger" style={{ marginTop: "-24px" }} role="alert">
      <i className="fa fa-exclamation-triangle"></i> <strong>Perhatian!</strong> {message}
    </div>
  );
}
